import { trackEvent } from '@offerzen/pinata-shame'

const viewPositionSource = previousLocation => {
  if (previousLocation?.includes('applications')) {
    return 'candidate applications'
  }

  if (previousLocation?.includes('jobs')) {
    return 'candidate positions recommendations'
  }

  return undefined
}

export const trackPageView = ({ previousLocation, jobName, jobId, candidateProfileId, companyName }) => {
  trackEvent('Candidate: position action', {
    action: 'viewed position',
    source: viewPositionSource(previousLocation),
    position_name: jobName,
    position_id: jobId,
    candidate_id: candidateProfileId,
    company_name: companyName,
  })
}
